import { cn } from "@/lib/utils";
import { SimpleTooltip } from "@/components/flowly/infra/SimpleTooltip/SimpleTooltip";
import type { LightboxActionButtonProps } from "./types";

export function LightboxActionButton({
  icon,
  label,
  onClick,
  colorClass,
  iconColorClass,
  disabled,
  tooltip,
}: LightboxActionButtonProps) {
  return (
    <SimpleTooltip content={tooltip}>
      <button
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
        className={cn(
          "flex items-center gap-2 md:gap-3 w-full p-2.5 md:p-3 rounded-xl md:rounded-2xl text-foreground font-bold transition-all",
          disabled
            ? "opacity-50 cursor-not-allowed"
            : cn("active:scale-95", colorClass)
        )}
      >
        <div
          className={cn(
            "w-8 h-8 md:w-9 md:h-9 rounded-lg md:rounded-xl flex items-center justify-center",
            iconColorClass
          )}
        >
          {icon}
        </div>
        <span className="text-xs md:text-sm">{label}</span>
      </button>
    </SimpleTooltip>
  );
}
